'use strict';

/*globals K2Application*/

function K2ApplicationSpecial(services) {
  K2Application.call(this, services);

  this.internetConnectionManager = null;
  this.printer = null;

  this.initSpecial();
}

K2ApplicationSpecial.prototype = $.extend({}, K2Application.prototype, {
  constructor: 'K2ApplicationSpecial',

  //**************************************************************************

  selectValue: function selectValue(data, callback) {
    var _this = this;

    _this.services.get('select-service').selectValue(data, callback);

    return _this;
  },

  getValue: function getValue(data, callback) {
    var _this = this;

    _this.services.get('input-service').getValue(data, callback);

    return _this;
  },

  getValueWithRes: function getValueWithRes(data, callback) {
    var _this = this;

    _this.services.get('input-service').getValueWithRes(data, callback);

    return _this;
  },

  closeMessage: function closeMessage() {
    var _this = this;

    _this.services.get('output-service').close();

    return _this;
  },

  showMessage: function showMessage(data, callback) {
    var _this = this;

    _this.services.get('output-service').showMessage(data, callback);

    return _this;
  },

  showMessageHtml: function showMessageHtml(data, callback) {
    var _this = this;

    _this.services.get('output-service').showMessageHtml(data, callback);

    return _this;
  },

  showWarningHtml: function showWarningHtml(data, callback) {
    var _this = this;

    _this.services.get('output-service').showWarningHtml(data, callback);

    return _this;
  },

  confirmHtml: function confirmHtml(data, callback) {
    var _this = this;

    _this.services.get('confirm-service').confirmHtml(data, callback);

    return _this;
  },

  confirmCancelHtml: function confirmCancelHtml(data, callback) {
    var _this = this;

    _this.services.get('confirm-service').confirmCancelHtml(data, callback);

    return _this;
  },

  //**************************************************************************

  initSpecial: function initSpecial() {
    var _this = this;

    _this.internetConnectionManager = _this.services.get('internet-connection-manager');
    _this.printer = _this.services.get('printing-service');

    return _this;
  }
});
